<template>
<div>
    <v-snackbar transition="scale-transition" style="z-index:100000001 !important;" app v-model="visible" :timeout="duration" top :color="type" >
      <i class="fa fa-spinner fa-spin fa-fw" />{{ message }}
        <v-btn  text @click.stop="cancelBtn" >
          关闭
        </v-btn>
    </v-snackbar>
</div>
</template>
<script>

export default {
  name: 'ErrMessage',
  // 定义的是默认数据, 默认值
  data() {
    return {
      visible: false, // 控制 DOM 显示隐藏
      type: 'success', // 默认 type 值为 default
      message: 'default', // 默认的 message 为空, 由外部传入
      duration: 5 * 1000, // 默认显示时间为 2 秒
      cancel: null // 关闭按钮事件
    };
  },
  methods: {
    cancelBtn() {
      if (this.cancel) {
        this.cancel();
      }
    }
  }
};
</script>
